export default {
  myLabellingStatus: {
    NotLabeled: '未标注',
    Pending: '等待审核',
    Passed: '审核通过',
    Rejected: '审核驳回',
  },
  tarReviewStatus: {
    Passed: '审核通过',
    Pending: '等待审核',
    Rejected: '审核驳回',
  },
}
